import { FC } from 'react'
import { createPortal } from 'react-dom'
import classNames from 'classnames'
import s from './dashboard.module.scss'

// Until Meta approves Advanced ads_read (plan §3.1), a client connects by
// sharing their ad account with the Hapttic business; we then switch on the
// sync. The self-serve "Connect" button replaces this after App Review.
const HAPTTIC_BUSINESS_ID = '527561502714866'

interface Props {
  isOpen: boolean
  onClose: () => void
}

export const ConnectModal: FC<Props> = ({ isOpen, onClose }) => {
  if (!isOpen) return null
  return createPortal(
    <div className={s.backdrop} onClick={onClose} role="presentation">
      <div
        className={classNames(s.modal, s.modalSmall)}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
      >
        <button
          aria-label="Close"
          className={s.close}
          onClick={onClose}
          type="button"
        >
          ×
        </button>
        <h2 className={s.modalTitle} style={{ marginBottom: 6 }}>
          Connect Accounts
        </h2>
        <p className={s.subtle} style={{ marginBottom: 20, marginTop: 0 }}>
          Track all your campaigns from one unified dashboard.
        </p>
        <div className={s.connectCard} style={{ marginBottom: 14 }}>
          <strong>Meta Ads</strong>
          <div className={s.subtle}>Facebook, Instagram &amp; WhatsApp</div>
          <ol className={s.steps}>
            <li>
              Open Meta Business Settings › Users › <b>Partners</b>.
            </li>
            <li>
              Add partner with Business ID <b>{HAPTTIC_BUSINESS_ID}</b>{' '}
              (Hapttic).
            </li>
            <li>
              Share your ad account with the view-performance (reporting) role
              only.
            </li>
            <li>
              Tell your Hapttic contact — we start syncing the last 90 days.
            </li>
          </ol>
        </div>
        <div className={s.connectGrid}>
          {[
            ['Google Ads', 'Google Ecosystem Ads'],
            ['LinkedIn', 'B2B Advertising'],
            ['TikTok Ads', 'Short-form video'],
          ].map(([name, sub]) => (
            <div className={s.connectCard} key={name}>
              <strong>{name}</strong>
              <div className={s.subtle}>{sub}</div>
              <div className={s.small} style={{ marginTop: 10 }}>
                Coming soon
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>,
    document.body
  )
}
